<span *ngIf="error"><ng-content></ng-content></span>